<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Tasa Vehículo
            <tasaVehiculoModal :listaDetalle="listaDetalle" :objModal="objModal"  :cabeceraModal="listGeneral.cabeceraModal" :listaEstados="listGeneral.listaEstado"/>
            
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Aseguradora *" color="textbox" v-model="objBusquedaTasa.idAseguradora"
                            :items="listGeneral.listaAseguradoras" item-text="aseguradora" item-value="idAseguradora"
                            :rules="requeridoRegla" @change="onListarSeguros" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Seguro *" color="textbox" v-model="objBusquedaTasa.idSeguro"
                            :items="listGeneral.listaSeguros" item-text="seguro" item-value="idSeguro"
                            :rules="requeridoRegla" @change="onListarProductos" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Producto *" color="textbox" v-model="objBusquedaTasa.idProducto"
                            :items="listGeneral.listaProductos" item-text="nombre_producto" item-value="id_producto"
                            :rules="requeridoRegla" @change="onListarProductosCobertura" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Cobertura *" color="textbox" v-model="objBusquedaTasa.idCobertura"
                            :items="listGeneral.listaCoberturas" item-text="cobertura" item-value="idCobertura"
                            :rules="requeridoRegla" @change="onCambiaCobertura" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado *" color="textbox" v-model="objBusquedaTasa.idEstado"
                            :items="listGeneral.listaEstado" item-text="nombre_estado" item-value="id_estado"
                            :rules="requeridoRegla" 
                            change="onListarSeguros"
                            outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field label="Póliza" v-model="objBusquedaTasa.idPoliza" disabled outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Rango Año *" color="textbox" v-model="objBusquedaTasa.idRangoAnio"
                            :items="listGeneral.listAnio" item-text="text" item-value="id" append-outer-icon="edit" @change="onCambiaFiltroMatriz"
                            outlined dense
                            @click:append-outer="objModal.abrirDialogo = true; objModal.idTipoRango = 1; onListarRango('anio','listAnio')" />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Rango Edad *" color="textbox" v-model="objBusquedaTasa.idRangoEdad"
                            :items="listGeneral.listaEdad" item-text="text" item-value="id" append-outer-icon="edit" @change="onCambiaFiltroMatriz"
                            outlined dense
                            @click:append-outer="objModal.abrirDialogo = true;objModal.idTipoRango = 2;onListarRango('edad','listaEdad')" />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Rango Valor Vehículo *" color="textbox"
                            v-model="objBusquedaTasa.idRangoValor" :items="listGeneral.listaValor" item-text="text"
                            item-value="id" append-outer-icon="edit" @change="onCambiaFiltroMatriz" outlined dense
                            @click:append-outer="objModal.abrirDialogo = true;objModal.idTipoRango = 3; onListarRango('valor','listaValor')" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Tipo Vehículo *" color="textbox" v-model="objBusquedaTasa.idTipoVehiculo"
                            :items="listGeneral.listaTipoVehiculo" @change="onCambiaFiltroMatriz" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Género *" color="textbox" v-model="objBusquedaTasa.idSexo"
                            :items="listGeneral.listaSexos" item-text="genero" item-value="idGenero" @change="onCambiaFiltroMatriz" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-btn class="text-center" rounded dark color="primary" @click="objPlantilla.abrirDialogo = true"> Buscar Plantilla</v-btn>
                        <clonarTasaComponent :objTasa="objPlantilla" :listaAseguradoras="_.get(listGeneral,'listaAseguradoras',[])" :parametros="parametros"/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                    </v-col>
                    <v-col cols="12" sm="4" class="text-center" v-show="_.size(objBusquedaTasa.idSexo) > 0">
                        <v-btn rounded dark color="primary" @click="onListarTasas">Generar Filas</v-btn>
                    </v-col>
                    <v-col cols="12" sm="4">
                    </v-col>
                </v-row>
                <v-row dense class="mt-5">
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objBusquedaTasa.buscar" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-form ref="form_lista_tasas">
                            <v-data-table :search="objBusquedaTasa.buscar" :headers="listGeneral.cabecera"
                                :items="listGeneral.listaDetalle" class="elevation-3">

                                <template v-slot:item.porcentaje="{ item }">
                                        <v-text-field color="textbox" dense v-model="item.porcentaje" :rules="_.concat(requeridoRegla,decimalTasa,tasaRegla)" />
                                </template>

                                <template v-slot:no-results>
                                    Tu búsqueda de "<span v-text="objBusquedaTasa.buscar"></span>" no arrojó resultados.
                                </template>
                            </v-data-table>
                        </v-form>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4"></v-col>
                    <v-col cols="12" sm="4" class="text-center" v-show="_.size(listGeneral.listaDetalle) > 0">
                        <v-btn rounded dark color="primary" :disabled="disabled" @click="insertaActualizaTasas">Guardar</v-btn>
                    </v-col>
                    <v-col cols="12" sm="4"></v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        name:'TasasView',
        components: {
            tasaVehiculoModal: () => import('@/components/constructor/tasa/ModalTasaComponent.vue'),
            clonarTasaComponent: () => import('@/components/constructor/tasa/ModalPlantillaTasaComponent.vue'),
        },
        data: () => ({
            disabled: false,
            band: false,
            listGeneral: {},
            parametros: {},
            objPlantilla: {
                titulo: 'Plantilla de Tasas de Productos',
                abrirDialogo: false
            },
            // todas las claves se declaran para que sean reactivas; si se asignan despues (this.obj.x = ...) el v-autocomplete no se entera al limpiarlas
            objBusquedaTasa: {
                idAseguradora: null,
                idSeguro: null,
                idProducto: null,
                idCobertura: null,
                idEstado: null,
                idPoliza: null,
                idRangoAnio: null,
                idRangoEdad: null,
                idRangoValor: null,
                idTipoVehiculo: null,
                idSexo: null,
                buscar: null
            },
            objModal: {
                titulo: '',
                idTipoRango: 0,
                abrirDialogo: false
            }
        }),
        created() {
            axios.post(`${BASE_URI}administrador/tasa-vehiculo/cargaGeneral`)
                .then((r) => {
                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion);
                    this.$set(this, 'listGeneral', r.data.data.listas);
                    this.$set(this, 'parametros', r.data.data.parametros);
                    this.$set(this.objBusquedaTasa, 'idEstado', _.toString(this.parametros.idEstadoDefault));
                    return this.onCargaGeneral();
                })
                .catch((e) => {
                    mensajesAlerta(e, 'E');
                });
        },
        computed: {
            listaDetalle() {
                this.objModal.idProducto = this.objBusquedaTasa.idProducto;
                this.objModal.idCobertura = this.objBusquedaTasa.idCobertura;
                switch (this.objModal.idTipoRango) {
                    case 1:
                        this.objModal.titulo = 'Rango Año';
                        this.objModal.nombreTabla = 'anio';
                        return this.listGeneral.listAnio;
                        break;
                    case 2:
                        this.objModal.titulo = 'Rango Edad';
                        this.objModal.nombreTabla = 'edad';
                        return this.listGeneral.listaEdad;
                        break;
                    case 3:
                        this.objModal.titulo = 'Rango Valor';
                        this.objModal.nombreTabla = 'valor';
                        return this.listGeneral.listaValor;
                        break;
                    default:
                        return [];
                        break;
                }
            }
        },
        methods: {
            onListar(ruta, objeto, lista) {
                return axios.post(`${BASE_URI}${ruta}`, objeto)
                    .then((r) => {
                        if (r.status != 200) throw mensajeEstandar.errorPeticion;
                        if (r.data.existeError) throw r.data.mensaje;
                        if (_.size(r.data.data) > 0) {
                            if (!_.isNull(lista))
                                this.$set(this.listGeneral, lista, r.data.data);
                        } else
                            mensajesAlerta(r.data.mensaje, 'I');

                        return r;
                    })
                    .catch((e) =>{
                        return e;
                    });
            },
            onCargaGeneral() {
                var objeto = {};

                this.onListar('administrador/aseguradora/listar', { opcion: 'LC' }, 'listaAseguradoras')
                    .then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        if (_.isNil(this.objBusquedaTasa.idAseguradora))
                            this.objBusquedaTasa.idAseguradora = this.listGeneral.listaAseguradoras[0].idAseguradora;

                            objeto = _.merge({},{ opcion: 'L_SEGURO'}, _.pick(this.objBusquedaTasa,['idAseguradora','idEstado']));
                            return this.onListar('administrador/producto/listar', objeto, 'listaSeguros');

                    }).then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                            this.objBusquedaTasa.idSeguro = this.listGeneral.listaSeguros[0].idSeguro;

                            objeto = _.merge({},{opcion: 'LISTARCOMBO'},_.pick(this.objBusquedaTasa,['idAseguradora','idSeguro','idEstado']));
                            return this.onListar('administrador/producto/listar', objeto, 'listaProductos');

                    }).then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        if (_.isNil(this.objBusquedaTasa.idProducto))
                            this.objBusquedaTasa.idProducto = this.listGeneral.listaProductos[0].id_producto;

                            objeto = _.merge({},{opcion: 'COBERTURAS_X_PRODUCTO'},_.pick(this.objBusquedaTasa,['idProducto','idEstado']));
                            return this.onListar('administrador/planCobertura/listar', objeto, null);

                    }).then((r)=>{
                        if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                            this.listGeneral.listaCoberturas = _.map(r.data.data, (v) => {  v.idCobertura = v.id_cobertura; return v; });
                            return r;

                    }).then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                            this.objBusquedaTasa.idCobertura = this.listGeneral.listaCoberturas[0].idCobertura;

                            objeto = _.merge({},{opcion: 'L_NRO_POLIZA'},_.pick(this.objBusquedaTasa,['idAseguradora','idProducto','idSeguro','idEstado']));
                            return this.onListar('administrador/producto/listar', objeto, null);

                    }).then((r) => {
                        var poliza = _.size(_.get(r,['data','data'],[])) > 0 ? r.data.data[0].poliza : '';
                        this.$set(this.objBusquedaTasa, 'idPoliza', poliza);
                        this.$forceUpdate();

                        return this.onListarTodosRango('e');
                    }).then((respuesta) => {
                        if (_.size(this.listGeneral.listaEdad) == 0 || _.size(this.listGeneral.listaValor) == 0 || 
                            _.size(this.listGeneral.listaTipoVehiculo) == 0 || _.size(this.listGeneral.listaSexos) == 0) throw mensajeEstandar.errorPeticion;

                        this.objBusquedaTasa.idRangoAnio = _.size(this.listGeneral.listAnio) > 0 ? this.listGeneral.listAnio[0].id : null;
                        this.objBusquedaTasa.idRangoEdad = this.listGeneral.listaEdad[0].id;
                        this.objBusquedaTasa.idRangoValor = this.listGeneral.listaValor[0].id;
                        this.objBusquedaTasa.idSexo = this.listGeneral.listaSexos[0].idGenero;
                        this.objBusquedaTasa.idTipoVehiculo = this.listGeneral.listaTipoVehiculo[0].value;
                        this.$forceUpdate();
                    })
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                    }).finally (() => {  this.band = true;});
            },
            onListarSeguros(e) {
                if (!_.isUndefined(e)) {
                    this.limpiar('lista', ['listaSeguros','listaProductos', 'listaCoberturas', 'listAnio', 'listaEdad', 'listaValor', 'listaDetalle', 'listaModal' ]);
                    this.limpiar('variable', ['idSeguro', 'idProducto','idCobertura','idRangoAnio', 'idRangoEdad', 'idRangoValor', 'idTipoVehiculo', 'idSexo', 'buscar', 'idPoliza' ]);
                        var objeto = _.merge({},{opcion: 'L_SEGURO'},_.pick(this.objBusquedaTasa,['idAseguradora','idEstado']));
                    
                        this.$set(this.objBusquedaTasa, 'idPoliza', null);
                        this.$set(this.objBusquedaTasa, 'idSeguro', null);
                        this.onListar('administrador/producto/listar', objeto, 'listaSeguros')
                            .catch((error) => {
                                mensajesAlerta(error, 'E');
                            });
                }
            },
            onListarProductos(e) {
                if (!_.isUndefined(e)) {
                    this.listGeneral.listaCoberturas = [];
                    var objeto = _.merge({},{opcion: 'LISTARCOMBO'},_.pick(this.objBusquedaTasa,['idAseguradora','idSeguro','idEstado']));
                    this.limpiar('lista', ['listaProductos','listaCoberturas', 'listAnio', 'listaEdad', 'listaValor', 'listaDetalle', 'listaModal' ]);
                    this.limpiar('variable', ['idCobertura','idProducto', 'idRangoAnio', 'idRangoEdad', 'idRangoValor', 'idTipoVehiculo', 'idSexo', 'buscar', 'idPoliza' ]);

                    this.onListar('administrador/producto/listar', objeto, null)
                        .then((r) => {
                            if (_.size(_.get(r,['data','data'],[])) > 0) {
                                if (_.size(r.data.data) > 0) {
                                    
                                    this.$set(this.listGeneral, 'listaProductos', r.data.data);
                                }
                            }
                        }).catch((error) => {
                            mensajesAlerta(error, 'E');
                        });
                }
            },
            onListarProductosCobertura(e) {
                if (!_.isUndefined(e)) {
                    var objeto = _.merge({},{opcion: 'L_NRO_POLIZA'},_.pick(this.objBusquedaTasa,['idAseguradora','idSeguro','idProducto','idEstado']));

                    this.limpiar('lista', ['listaCoberturas', 'listAnio', 'listaEdad', 'listaValor', 'listaDetalle', 'listaModal']);
                    this.limpiar('variable', ['idCobertura', 'idRangoAnio', 'idRangoEdad', 'idRangoValor', 'idTipoVehiculo', 'idSexo', 'buscar']);
                    this.$set(this.objBusquedaTasa, 'idPoliza', null);
                    this.onListar('administrador/producto/listar', objeto, null)
                        .then((r) => {
                            if (_.size(_.get(r,['data','data'],[])) > 0) {
                                this.$set(this.objBusquedaTasa, 'idPoliza', r.data.data[0].poliza);
                                this.onListarCobertura();
                            }
                        }).catch((ex) => {
                            mensajesAlerta(ex, 'E');
                        });

                }
            },
            onListarCobertura() {
                this.limpiar('lista', ['listAnio', 'listaEdad', 'listaValor', 'listaDetalle','listaCoberturas']);
                this.limpiar('variable', ['idRangoAnio', 'idRangoEdad', 'idRangoValor', 'idTipoVehiculo', 'idSexo', 'buscar']);

                var objeto = _.merge({},{opcion: 'COBERTURAS_X_PRODUCTO'},_.pick(this.objBusquedaTasa,['idProducto','idEstado']));

                this.onListar('administrador/planCobertura/listar', objeto, null)
                    .then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) > 0) {
                            this.listGeneral.listaCoberturas = _.map(r.data.data, (v) => { v.idCobertura = v.id_cobertura; return v; });
                        }
                        return r;
                    })
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                    });
            },
            onCambiaCobertura(e) {
                if (!_.isUndefined(e)) {
                    this.limpiar('variable', ['idRangoAnio', 'idRangoEdad', 'idRangoValor', 'idTipoVehiculo', 'idSexo', 'buscar']);
                    this.limpiar('lista', ['listaModal']);
                    return this.onListarTodosRango(e);
                }
            },
            onCambiaFiltroMatriz() {
                // las filas generadas dependen de los filtros, se descartan al cambiarlos
                this.limpiar('lista', ['listaDetalle']);
            },
            onListarTodosRango(e) {
                if (!_.isUndefined(e)) {
                    this.limpiar('lista', ['listAnio', 'listaEdad', 'listaValor', 'listaDetalle']);
                    var request = [
                                        this.onListarRango('anio', 'listAnio'), 
                                        this.onListarRango('edad', 'listaEdad'), 
                                        this.onListarRango('valor', 'listaValor') 
                                   ];

                    return Promise.all(request)
                                  .then((respuesta) => {
                                        return respuesta;
                                    });
                }
            },
            onListarRango(nombreTablaRango, lista, idProducto = null, idCobertura = null) {
                var objeto = {
                    opcion: 'LISTAR_RANGO',
                    nombreTabla: nombreTablaRango,
                    idProducto: _.isNull(idProducto) ? this.objBusquedaTasa.idProducto : idProducto,
                    idCobertura: _.isNull(idCobertura) ? this.objBusquedaTasa.idCobertura : idCobertura
                }
                return this.onListar('administrador/rango-vehiculo/listar', objeto, null)
                    .then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) > 0) {
                            var l = _.map(r.data.data, (val) => { val.text = `${val.valor_min} - ${val.valor_max}`; val.index = _.uniqueId(); return val });
                            this.$set(this.listGeneral, lista, l );
                            this.$set(this.listGeneral, 'listaModal', l );
                            this.$forceUpdate();
                        }
                        return r;
                    });
            },
            onListarTasas() {
                try {
                    var objeto = _.clone(this.objBusquedaTasa);
                    if (_.size(objeto.idRangoAnio) == 0) throw 'Debe seleccionar un rango de año.';
                    if (_.size(objeto.idRangoEdad) == 0) throw 'Debe seleccionar un rango de edad.';
                    if (_.size(objeto.idRangoValor) == 0) throw 'Debe seleccionar un rango de valor.';
                    if (_.size(objeto.idTipoVehiculo) == 0) throw 'Debe seleccionar un tipo de vehículo.';
                    if (_.size(objeto.idSexo) == 0) throw 'Debe seleccionar un género.';

                    objeto.opcion = 'LISTAR_TASAS';
                    _.forEach(['idRangoAnio', 'idRangoEdad', 'idRangoValor', 'idTipoVehiculo', 'idSexo'], (v) => {
                        _.set(objeto, v, _.toNumber(_.get(objeto, v)) == 0 ? null : _.get(objeto, v));
                    });

                    return this.onListar('administrador/tasa-vehiculo/listar', objeto, null)
                        .then((respuesta) => {
                            if (_.size(_.filter(this.listGeneral.listaEdad, (o) => { return _.toLower(o.visualiza) == _.toLower('true') })) == 0) throw 'No se encontro datos en rango de edad.';
                            if (_.size(_.filter(this.listGeneral.listaValor, (o) => { return _.toLower(o.visualiza) == _.toLower('true') })) == 0) throw 'No se encontro datos en rango de valor.';
                            if (_.size(_.filter(this.listGeneral.listaTipoVehiculo, (o) => { return _.toLower(o.visualiza) == _.toLower('true') })) == 0) throw 'No se encontro datos en tipo de vehículo.';
                            if (_.size(_.filter(this.listGeneral.listaSexos, (o) => { return _.toLower(o.visualiza) == _.toLower('true') })) == 0) throw 'No se encontro datos de género.';
                            if (_.size(_.filter(this.listGeneral.listaEdad, (o) => { return _.toLower(o.visualiza) == _.toLower('true') })) == 0) throw 'No se encontro datos en rango de edad.';

                                this.onGenerarMatrizTasa(respuesta.data.data);
                                return respuesta;
                        });
                } catch (error) {
                    mensajesAlerta(error, 'I');
                }
            },
            onGenerarMatrizTasa(lista) {
                this.$set(this.listGeneral, 'listaDetalle', []);
                var listProducto = _.filter(_.map(this.listGeneral.listaProductos, (v) => {
                    v.id = v.id_producto;
                    v.text = v.nombre_producto;
                    return v;
                }), (o) => {
                    if (!_.isUndefined(this.objBusquedaTasa.idProducto) && !_.isNull(this.objBusquedaTasa.idProducto) && this.objBusquedaTasa.idProducto != 0) {
                        return o.id == this.objBusquedaTasa.idProducto;
                    } else
                        return o.id != 0
                });

                var listCobertura = _.filter(_.map(this.listGeneral.listaCoberturas, (v) => { 
                                                                                                v.id = v.idCobertura; 
                                                                                                v.text = v.cobertura; 
                                                                                                return v;
                                            }), (o) => {
                                                if (!_.isUndefined(this.objBusquedaTasa.idCobertura) && !_.isNull(this.objBusquedaTasa.idCobertura) && this.objBusquedaTasa.idCobertura != 0) 
                                                    return o.id == this.objBusquedaTasa.idCobertura;
                                                else
                                                    return o.id != 0
                                            });


                var listAnio = _.filter(this.listGeneral.listAnio, (o) => {
                                                                            if ( 
                                                                                 !_.isUndefined(this.objBusquedaTasa.idRangoAnio) && 
                                                                                 !_.isNull(this.objBusquedaTasa.idRangoAnio) && 
                                                                                 this.objBusquedaTasa.idRangoAnio != 0
                                                                                ) 
                                                                                    return o.id == this.objBusquedaTasa.idRangoAnio;
                                                                            else
                                                                                return o.id != 0;
                                                                            });

                var listEdad = _.filter(this.listGeneral.listaEdad, (o) => {
                                                                                if (  
                                                                                        !_.isUndefined(this.objBusquedaTasa.idRangoEdad) && 
                                                                                        !_.isNull(this.objBusquedaTasa.idRangoEdad) && 
                                                                                        this.objBusquedaTasa.idRangoEdad != 0
                                                                                    ) 
                                                                                    return o.id == this.objBusquedaTasa.idRangoEdad;
                                                                                else
                                                                                    return o.id != 0;
                                                                            });

                var listTipoVehi = _.filter(_.map(this.listGeneral.listaTipoVehiculo, (v) => { v.id = v.value; return v; }), (o) => {
                                                                                        if (
                                                                                                !_.isUndefined(this.objBusquedaTasa.idTipoVehiculo) && 
                                                                                                !_.isNull(this.objBusquedaTasa.idTipoVehiculo) && 
                                                                                                this.objBusquedaTasa.idTipoVehiculo != 0
                                                                                            ) 
                                                                                            return o.value == this.objBusquedaTasa.idTipoVehiculo;
                                                                                        else
                                                                                            return o.value != 0;
                                                                                    });

                var listValor = _.filter(this.listGeneral.listaValor, (o) => {
                                                                                if (
                                                                                        !_.isUndefined(this.objBusquedaTasa.idRangoValor) && 
                                                                                        !_.isNull(this.objBusquedaTasa.idRangoValor) &&
                                                                                        this.objBusquedaTasa.idRangoValor != 0
                                                                                    ) 
                                                                                    return o.id == this.objBusquedaTasa.idRangoValor;
                                                                                else
                                                                                    return o.id != 0;
                                                                            });

                var listSexo = _.filter(_.map(this.listGeneral.listaSexos, (v) => { v.id = v.idGenero; v.text = v.genero; return v; }), 
                                                                            (o) => {
                                                                                        if (
                                                                                                !_.isUndefined(this.objBusquedaTasa.idSexo) && 
                                                                                                !_.isNull(this.objBusquedaTasa.idSexo) &&
                                                                                                this.objBusquedaTasa.idSexo != 0
                                                                                            ) 
                                                                                            return o.id == this.objBusquedaTasa.idSexo;
                                                                                        else
                                                                                            return o.id != 0;
                                                                                    });



                var cp = Combinatorics.cartesianProduct(
                                                            this.obtenerArray(listProducto), 
                                                            this.obtenerArray(listCobertura), 
                                                            this.obtenerArray(listTipoVehi), 
                                                            this.obtenerArray(listAnio),
                                                            this.obtenerArray(listEdad), 
                                                            this.obtenerArray(listValor), 
                                                            this.obtenerArray(listSexo)
                                                        );

                var t = _.orderBy(_.map(cp.toArray(), (v, k) => {
                        var rango = _.map(_.split(v[5], '-'), _.parseInt);
                        v.push(rango[0]);
                        v.push(_.sum(_.map(_.split(v[5], '-'), _.parseInt)));
                        return v;
                    }),
                    [2, 3, 4, 7, 6], ['asc', 'asc', 'asc', 'asc', 'asc']);

                var listaTasas = [];
                _.map(t, (v, k) => {
                    listaTasas.push({
                        idProducto: (_.find(listProducto, (o) => { return _.trim(o.text) == _.trim(v[0]) })).id,
                        producto: v[0],

                        idCobertura: (_.find(listCobertura, (o) => { return _.trim(o.text) == _.trim(v[1]) })).id,
                        cobertura: v[1], idTipoVehiculo: (_.find(listTipoVehi, (o) => { return _.trim(o.text) == _.trim(v[2]) })).id,

                        tipoVehiculo: v[2],

                        idRangoAnio: (_.find(listAnio, (o) => { return _.trim(o.text) == _.trim(v[3]) })).id,
                        
                        rangoAnio: v[3], idRangoEdad: (_.find(listEdad, (o) => { return _.trim(o.text) == _.trim(v[4]) })).id,
                        
                        rangoEdad: v[4],
                        
                        idRangoValor: (_.find(listValor, (o) => { return _.trim(o.text) == _.trim(v[5]) })).id,
                        
                        rangoValor: v[5],
                        
                        idSexo: (_.find(listSexo, (o) => { return _.trim(o.text) == _.trim(v[6]) })).id,
                        
                        genero: v[6],
                        
                        porcentaje: "0.00000"
                    })
                });
                console.table(listaTasas);
                if (_.size(lista) > 0) {
                    _.forEach(lista, (v, k) => {
                        _.forEach(listaTasas, (d, i) => {
                            if (
                                    parseInt(v.idProducto) == parseInt(d.idProducto) && parseInt(v.idCobertura) == parseInt(d.idCobertura) && 
                                    parseInt(v.idTipoVehiculo) == parseInt(d.idTipoVehiculo) && parseInt(v.idRangoAnio) == parseInt(d.idRangoAnio) &&
                                    parseInt(v.idRangoEdad) == parseInt(d.idRangoEdad) && parseInt(v.idRangoValor) == parseInt(d.idRangoValor) &&
                                    parseInt(v.idSexo) == parseInt(d.idSexo)
                                )
                                    d = _.merge(d, v);
                        });
                    });
                }
                this.listGeneral.listaDetalle = listaTasas;
            },
            obtenerArray(arreglo) {
                var lista = _.transform(arreglo, (r, v) => {
                    r.push(v.text);
                }, []);

                return _.uniq(lista);
            },
            cerrar() {
                this.objModal = {
                    titulo: '',
                    idTipoRango: 0,
                    abrirDialogo: false
                };
            },
            cerrarModalPlantilla() {
                this.objPlantilla = {
                                        titulo: 'Plantilla de Tasas de Productos',
                                        abrirDialogo: false
                                    };
            },
            insertarActualizar(opcion, objeto) {
                this.disabled = true;
                var url = opcion != 'RANGO' ? 'administrador/tasa-vehiculo/insertOrUpdate' : 'administrador/rango-vehiculo/insertOrUpdate';
                return axios.post(`${BASE_URI}${url}`, objeto)
                            .then((r) => {
                                if (r.status != 200) throw mensajeEstandar.errorPeticion;
                                if (_.get(r,['data','existeError'],true)) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);

                                    mensajeAlertaTiempo(r.data.mensaje, 'S');
                                    this.disabled = false;
                                    return this.onListarTodosRango('e');
                            })
                            .then((r)=>{
                                return true;
                            })
                            .catch((e) => {
                                mensajesAlerta(e, 'E');
                                this.disabled = false;
                                return false;
                            });
            },
            limpiar(evento, array) {
                if (this.band) {
                    switch (evento) {
                        case 'lista':
                            _.forEach(array, (v) => {
                                this.$set(this.listGeneral, v, []);
                                // evita enviar al guardar el detalle de la consulta anterior
                                if (v == 'listaDetalle') this.$set(this.objBusquedaTasa, 'listaDetalle', []);
                            });
                            break;
                        case 'variable':
                            _.forEach(array, (v) => {
                                this.$set(this.objBusquedaTasa, v, null);
                            });
                            break;
                    }
                }
            },
            insertaActualizaTasas() {
                this.listGeneral.listaDetalle = _.map(this.listGeneral.listaDetalle, (v) => { 
                                                                                                v.porcentaje = _.toNumber(v.porcentaje) <= 0 ? 0.05000 : v.porcentaje;
                                                                                                return v;
                                                                                            });

                if (this.$refs.form_lista_tasas.validate()) {
                    this.objBusquedaTasa.listaDetalle = this.listGeneral.listaDetalle;
                    this.objBusquedaTasa.opcion = _.isUndefined(this.listGeneral.listaDetalle[0].id) ? 'I_TASA' : 'U_TASA';
                    this.insertarActualizar('TASA', this.objBusquedaTasa);
                } else
                    mensajesAlerta(mensajeEstandar.corregirInformacion, 'I');
            }
        },
        provide() {
            return {
                insertarActualizar: this.insertarActualizar,
                cerrar: this.cerrar,
                cerrarModalPlantilla: this.cerrarModalPlantilla,
            }
        },
    }
</script>